import React from 'react';
import { Link } from 'react-router-dom';
import { Socials } from "./Socials";
import './Footer.scss';
import rataMemberIcon from '../assets/rata_member.svg';

export function Footer() {
    return (
        <footer className='footer'>
            <div className='footer__wrapper'>
                <div className='footer__container'>
                    Oбщество с ограниченной ответственностью "Вояж Глобал" УНП 193765582
                    <div className='footer__container-info'>
                        <p>Республика Беларусь, г.Минск, ул.В.Хоружей,3, офис 305а</p>
                        <p>Время работы:</p>
                        <p>пн-пт: 09:00 - 18:00</p>
                        <p>сб-вскр: по предварительной записи</p>
                    </div>
                </div>
                <Socials/>
                <a
                    target='_blank'
                    href='https://rata.by/'
                >
                    <img
                        src={rataMemberIcon}
                        alt='rata member'
                    />
                </a>
            </div>
            <div className='footer__wrapper footer__links'>
                <Link to='/privacy-policy'>Политика конфиденциальности</Link>
                <Link to='/cookie-policy'>Политика cookie</Link>
            </div>
            <div className='footer__wrapper text'>© 2024, Вояж Глобал</div>
        </footer>
    )
}
